import React,{Component} from "react";
import {AppBackground, MediumFont, TextColor, ThinBorder} from '../../styles/BaseStyles';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import TimeCard from "./TimeCard";
import EnviroCard from "./EnviroCard";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";



const Styles = theme => ({
    root: Object.assign({}, AppBackground, MediumFont),
    gridPane: {width: '50%', display: 'inline-block'},
    paneTable: {width: '100%', height: '100%',  backgroundColor:'grey'},
    videoPane: {width: '50%', display: 'inline-block', verticalAlign: 'top'},
    penInfoPanel: {color: 'white', fontSize: 20},
    penInfoPanelSelected: Object.assign({color: 'white', fontSize: 20}, ThinBorder),
    videoPanel: {marginTop: 0},
    penName: {color: TextColor, fontSize: 20, marginLeft: 10, cursor: 'pointer', display: 'inline-block'},
    metricValue: {display: 'inline-block', width: 100, height: 100, cursor: 'pointer'},
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    metricInfo: Object.assign({}, AppBackground, ThinBorder)

});

const styles = theme => ({
    container: {
        display: 'grid',
        gridTemplateColumns: 'repeat(12, 1fr)',
        gridGap: `${theme.spacing.unit * 3}px`,
    },
    paper: {
        padding: theme.spacing.unit,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        whiteSpace: 'nowrap',
        marginBottom: theme.spacing.unit,
    },
    divider: {
        margin: `${theme.spacing.unit * 2}px 0`,
    },
    leftPane: {width: '25%', height: '100%', verticalAlign: 'top', backgroundColor:'red'},
    rightPane: {fontSize: 40, color: 'black', verticalAlign: 'top', backgroundcolor:'red'},
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2,
    },
    button: {
        margin: theme.spacing.unit,
    },
    extendedIcon: {
        marginRight: theme.spacing.unit,
    },
    margin: {
        margin: theme.spacing.unit * 2,
    },
});


class SaveEnviro extends Component {

    state = {
        age: '',
        name: 'hai',
    };

    handleChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    //<div  marginTop={100}  paddingTop={30} width={400} height={1000} style = { {  backgroundImage: 'url(' + require('../../images/IMG_1.JPG') + ')',  backgroundPosition:'center',  backgroundSize:'cover',  backgroundRepeat:'no-repeat', height:800 }}>
    //                                        <div  style = { { backgroundPosition:'center',  backgroundSize:'cover',  backgroundRepeat:'no-repeat', height:40 , paddingTop:50,  paddingLeft:70}}  >

    render() {
        const { classes } = this.props;
        return (
            <div >

                <Grid container spacing={24}>

                    <Grid   item xs={12} sm={12}  style={Styles.rightPane}>
                            <div width="100%" height={600}>
                                <div>
                                    <div  margintop={100}  paddingtop={30} width={400} height={600} style = { {  backgroundImage: 'url(/static/images/IMG_2981.JPG)',  backgroundPosition:'center',  backgroundSize:'cover',  backgroundRepeat:'no-repeat', height:600 }}>
                                       <div  style = { { backgroundPosition:'center',  backgroundSize:'cover',  backgroundRepeat:'no-repeat', height:40 , paddingTop:50,  paddingLeft:190}}  >

                                        <Grid container spacing={24} style = { { textAlign: 'center', alignSelf: 'center', paddingTop:'20' }}>

                                        <Grid   item xs={5} sm={5}  >

                                                </Grid>
                                                <Grid   item xs={2} sm={2}  >
                                                <Button  variant="outlined" href="#vehicleowner"  style = { { textAlign: 'center', alignSelf: 'center',borderSize:'4',borderRadius:'4', bordered:'true', backgroundColor:'transparent',  borderColor:'#e2580d' ,color:'black',
                                                boxShadow: '1px 3px 5px 2px rgb(226, 88, 13, .3)',fontSize:12}}>
                                            Vehicle Owners
                                            </Button>


                                            </Grid>
                                            <Grid   item xs={2} sm={2}   >
                                                <Button variant="outlined" href="#towtruck"   style = { { textAlign: 'center', alignSelf: 'center',borderSize:'2',borderRadius:'4', bordered:'true', backgroundColor:'transparent',  borderColor:'#0a9110' ,color:'black',
                                                boxShadow: '1px 3px 5px 2px rgb(10, 145, 16, .3)',fontSize:12}}>
                                            Tow Companies
                                            </Button>

                                            </Grid>
                                            <Grid   item xs={2} sm={2}   >
                                                <Button variant="outlined" href="#city"  style = { { textAlign: 'center', alignSelf: 'center',borderSize:'2',borderRadius:'4', bordered:'true', backgroundColor:'transparent',  borderColor:'#540a91' ,color:'black',
                                                boxShadow: '1px 3px 5px 2px rgb(84, 10, 145, .3)', fontSize:12}}>
                                                Municipality
                                            </Button>

                                            </Grid>
                                            <Grid   item xs={1} sm={1}  >

                                            </Grid>

                                            </Grid>
                                                    <Typography variant="h4" gutterBottom  align="left">
                                                    Save Environment
                                                </Typography>

                                                <Typography variant="h6"  color = 'secondary'  align="left">
                                                    _____________________________________________
                                                    </Typography>
                                                    <Typography variant="h5" gutterBottom  align="left">
                                                    Reduce Co2 emissions by eliminating unnecessary vehicle traffic!
                                                </Typography>
                                            {/*
                                            <h2 style = { { color:'white', fontSize:40}} >Save Environment </h2>
                                                <h2 style = { { color:'Red', fontSize:20}} >_______________________________ </h2>
                                                <h4 style = { { color:'black', fontSize:30}}>Reduce Co2 by eliminating unnecessary vehicle traffic!    </h4>
                                                */}

                                        </div>
                                            <div   style = {{ paddingTop:130, paddingLeft:190}}>
                                                    <EnviroCard></EnviroCard>
                                            </div>

                                    </div>
                                </div>
                            </div>
                    </Grid>



                    </Grid>
            </div>


    );
    }
}

SaveEnviro.propTypes = {
    classes: PropTypes.object.isRequired,
};
//export default BiomassView;
export default withStyles(styles)(SaveEnviro);